import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoborivalicab() {



  const cardData = {


  keyword: "Pune to Borivali Cab",

  headingDescription: "Trustline Cab provides reliable Pune to Borivali cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family visits, medical appointments, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups and a smooth, hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Borivali taxi services.",

  topPlaces: [
    {
      title: "Borivali East",
      description: "Borivali East is a prominent commercial and residential hub known for corporate offices, business complexes, educational institutions, hospitals, and excellent connectivity through the Western Express Highway and Mumbai Metro. It is a preferred destination for professionals, families, and business travelers visiting Mumbai."
    },
    {
      title: "Borivali West",
      description: "Borivali West is one of Mumbai's busiest suburbs, offering shopping centers, commercial establishments, premium residential neighborhoods, restaurants, and convenient railway connectivity. The locality attracts visitors for business, family functions, and leisure activities throughout the year."
    },
    {
      title: "Kandivali",
      description: "Kandivali is a fast-growing business and residential locality featuring corporate offices, industrial estates, retail outlets, educational institutions, and modern infrastructure. Its strategic location makes it an important destination for professionals and commercial visitors."
    },
    {
      title: "Malad",
      description: "Malad is a major commercial destination with IT parks, business centers, shopping malls, multinational companies, and premium office spaces. It serves as an important hub for corporate travel and professional meetings in western Mumbai."
    },
    {
      title: "Infinity IT Park",
      description: "Infinity IT Park is a well-known technology and business campus housing software companies, IT service providers, startups, and multinational organizations. It is a popular destination for professionals visiting Mumbai for corporate work."
    },
    {
      title: "Mindspace Malad",
      description: "Mindspace Malad is one of Mumbai's leading corporate parks featuring global companies, financial institutions, technology firms, and premium commercial infrastructure. It attracts thousands of business professionals every day."
    },
    {
      title: "Sanjay Gandhi National Park",
      description: "Sanjay Gandhi National Park is one of India's largest protected urban forests, offering wildlife experiences, lush greenery, cycling tracks, boating, and numerous recreational activities. It is a favorite destination for nature lovers and families."
    },
    {
      title: "Kanheri Caves",
      description: "Located within Sanjay Gandhi National Park, the Kanheri Caves are ancient Buddhist rock-cut monuments featuring intricate carvings, meditation halls, and centuries-old architecture. They are among Mumbai's most significant historical and cultural attractions."
    },
    {
      title: "Gorai Beach",
      description: "Gorai Beach is a peaceful coastal destination offering golden sands, ferry rides, beach resorts, seafood restaurants, and beautiful sunset views. It is a popular weekend getaway for families and tourists visiting the western suburbs."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is an internationally renowned meditation center featuring one of the world's largest stone domes. Its peaceful environment, impressive architecture, and spiritual significance make it a must-visit attraction near Borivali."
    }
  ],






"services": [
  {
    "name": "Borivali to Pune Cab",
    "description": "Book Borivali to Pune Cab for safe, comfortable, and affordable intercity travel with professional chauffeurs and clean AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, and premium cars for one-way trips, round trips, airport transfers, corporate travel, family vacations, business meetings, and weekend journeys. Enjoy doorstep pickup, transparent pricing, spacious luggage capacity, flexible travel schedules, sanitized vehicles, and 24x7 customer support for a smooth journey."
  },
  {
    "name": "Borivali to Pune Cab Service",
    "description": "Our Borivali to Pune Cab Service provides reliable one-way and round-trip transportation with experienced drivers, clean AC vehicles, transparent pricing, timely pickup, comfortable seating, and dependable customer support for business, family, and leisure travel."
  },
  {
    "name": "Borivali to Pune Car",
    "description": "Hire a Borivali to Pune Car with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for comfortable intercity travel, corporate trips, airport transfers, family vacations, and private transportation."
  },
  {
    "name": "Borivali to Pune Taxi Fare",
    "description": "Check Borivali to Pune Taxi Fare with fixed pricing, affordable packages, transparent billing, and multiple vehicle options including Sedan, Ertiga, Innova Crysta, SUV, and premium cars."
  },
  {
    "name": "Borivali to Pune Taxi",
    "description": "Choose Borivali to Pune Taxi for reliable long-distance travel with professional chauffeurs, well-maintained AC vehicles, affordable fares, and comfortable transportation for business and personal journeys."
  },
  {
    "name": "Borivali to Pune Taxi Service",
    "description": "Book Borivali to Pune Taxi Service with experienced drivers, premium vehicles, punctual pickup, transparent pricing, and dependable customer support for stress-free intercity travel."
  },
  {
    "name": "Pune to Borivali Cab",
    "description": "Book Pune to Borivali Cab for comfortable, safe, and affordable intercity travel with chauffeur-driven AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, railway station transfers, and weekend journeys."
  },
  {
    "name": "Pune to Borivali Cab Service",
    "description": "Our Pune to Borivali Cab Service offers reliable one-way and round-trip transportation with professional drivers, transparent pricing, clean vehicles, timely pickup, and comfortable travel for families, tourists, and corporate clients."
  },
  {
    "name": "Pune to Borivali Taxi",
    "description": "Reserve a Pune to Borivali Taxi with experienced chauffeurs, sanitized AC vehicles, fixed pricing, and convenient doorstep pickup for safe and hassle-free intercity travel."
  },
  {
    "name": "Pune to Borivali Taxi Service",
    "description": "Choose Pune to Borivali Taxi Service for dependable transportation with premium vehicles, punctual pickup, affordable fares, and excellent customer support."
  },
  {
    "name": "Pune to Borivali Cab Booking",
    "description": "Complete your Pune to Borivali Cab Booking with instant confirmation, multiple vehicle choices, transparent fares, secure online reservation, and professional chauffeur service."
  },
  {
    "name": "Online Pune to Borivali Cab Booking",
    "description": "Use Online Pune to Borivali Cab Booking for quick reservations, instant confirmation, secure payment options, affordable pricing, and reliable chauffeur-driven travel."
  },
  {
    "name": "Book Pune to Borivali Cab",
    "description": "Book Pune to Borivali Cab anytime with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles offering comfortable travel, experienced drivers, and 24x7 booking assistance."
  },
  {
    "name": "Pune to Borivali One Way Cab",
    "description": "Choose Pune to Borivali One Way Cab and pay only for your single journey while enjoying affordable fares, clean AC vehicles, and professional chauffeur service."
  },
  {
    "name": "Pune to Borivali Round Trip Cab",
    "description": "Book Pune to Borivali Round Trip Cab with flexible return schedules, premium vehicles, transparent pricing, and experienced drivers for convenient intercity travel."
  },
  {
    "name": "Pune to Borivali Outstation Cab",
    "description": "Travel comfortably with Pune to Borivali Outstation Cab featuring safe highway travel, professional chauffeurs, clean AC vehicles, and dependable customer support."
  },
  {
    "name": "Pune to Borivali Car Rental",
    "description": "Choose Pune to Borivali Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for business travel, family vacations, and airport transfers."
  },
  {
    "name": "Pune to Borivali Private Cab",
    "description": "Hire Pune to Borivali Private Cab for exclusive travel with flexible pickup timing, comfortable seating, experienced drivers, and complete privacy throughout the journey."
  },
  {
    "name": "Pune to Borivali AC Cab",
    "description": "Book Pune to Borivali AC Cab with well-maintained air-conditioned vehicles, professional chauffeurs, affordable fares, and comfortable long-distance transportation."
  },
  {
    "name": "Pune to Borivali Intercity Cab",
    "description": "Our Pune to Borivali Intercity Cab service provides reliable, affordable, and safe transportation with experienced drivers, premium vehicles, and transparent pricing."
  },
  {
    "name": "Pune to Borivali Drop Taxi",
    "description": "Choose Pune to Borivali Drop Taxi for direct destination drop with fixed pricing, clean AC vehicles, professional chauffeurs, and dependable intercity transportation."
  },
  {
    "name": "Pune to Borivali Travel Cab",
    "description": "Book Pune to Borivali Travel Cab for business travel, family outings, corporate trips, holiday journeys, and personal travel with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Pune to Borivali Taxi Booking",
    "description": "Complete your Pune to Borivali Taxi Booking online with instant confirmation, transparent fares, multiple vehicle choices, and reliable taxi services."
  },
  {
    "name": "Pune to Borivali Cab Hire",
    "description": "Hire Pune to Borivali Cab with professional drivers, premium AC vehicles, affordable pricing, and dependable customer support for comfortable intercity travel."
  },
  {
    "name": "Pune to Borivali Rental Cab",
    "description": "Choose Pune to Borivali Rental Cab with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible, comfortable, and convenient long-distance travel."
  }
],

"tableData": [
  ["Borivali to Pune Cab", "Borivali to Pune Cab Service"],
  ["Borivali to Pune Car", "Borivali to Pune Taxi Fare"],
  ["Borivali to Pune Taxi", "Borivali to Pune Taxi Service"],
  ["Pune to Borivali Cab", "Pune to Borivali Cab Service"],
  ["Pune to Borivali Taxi", "Pune to Borivali Taxi Service"],
  ["Pune to Borivali Cab Booking", "Online Pune to Borivali Cab Booking"],
  ["Book Pune to Borivali Cab", "Pune to Borivali One Way Cab"],
  ["Pune to Borivali Round Trip Cab", "Pune to Borivali Outstation Cab"],
  ["Pune to Borivali Car Rental", "Pune to Borivali Private Cab"],
  ["Pune to Borivali AC Cab", "Pune to Borivali Intercity Cab"],
  ["Pune to Borivali Drop Taxi", "Pune to Borivali Travel Cab"],
  ["Pune to Borivali Taxi Booking", "Pune to Borivali Cab Hire"],
  ["Pune to Borivali Rental Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Borivali Cab Service",
    WhyChoosedescription: "Trustline Travels offers safe and comfortable Pune to Borivali cab services with reliable vehicles for business trips, family travel, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Drop Facility",
    WhyChoosedescription: "Enjoy convenient pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations with direct drop anywhere in Borivali."
  },
  {
    WhyChooseheading: "Comfortable Outstation Travel",
    WhyChoosedescription: "Travel in well-maintained vehicles equipped for long-distance journeys, ensuring maximum comfort throughout your Pune to Borivali trip."
  },
  {
    WhyChooseheading: "Professional Highway Chauffeurs",
    WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai-Pune Expressway and provide a smooth, safe, and punctual travel experience."
  },
  {
    WhyChooseheading: "Fair Pricing Without Hidden Costs",
    WhyChoosedescription: "Receive transparent fare quotations with competitive pricing and complete clarity before confirming your Pune to Borivali cab booking."
  },
  {
    WhyChooseheading: "Wide Choice of Vehicles",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel preferences and luggage requirements."
  },
  {
    WhyChooseheading: "Flexible One-Way & Return Bookings",
    WhyChoosedescription: "Choose one-way travel, round-trip cabs, or personalized travel plans designed to match your schedule."
  },
  {
    WhyChooseheading: "Easy Online Booking & 24/7 Support",
    WhyChoosedescription: "Book your Pune to Borivali cab in minutes with instant confirmation and dedicated customer assistance available anytime."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Borivali cab service?",
    answer: "Yes, Trustline Cab offers dependable Pune to Borivali cab services for one-way trips, round trips, airport transfers, business travel, and family journeys."
  },
  {
    question: "Can I reserve a one-way cab from Pune to Borivali?",
    answer: "Yes, affordable one-way cab services are available with doorstep pickup from any location in Pune."
  },
  {
    question: "Which vehicles are available for Pune to Borivali travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your passenger count and travel needs."
  },
  {
    question: "Do you provide pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we offer pickup services from Pune Airport, Pune Railway Station, hotels, offices, and residential areas across Pune."
  },
  {
    question: "Can I book a round-trip cab to Borivali?",
    answer: "Yes, we provide flexible round-trip cab packages for business travel, family visits, and personal trips."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Pune to Borivali cab service available throughout the day?",
    answer: "Yes, Trustline Travels operates 24/7, allowing you to book a cab at any time that suits your travel schedule."
  },
  {
    question: "Can I pre-book my Pune to Borivali cab?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup timing."
  },
  {
    question: "Is this cab service suitable for business and family travel?",
    answer: "Yes, our Pune to Borivali cab service is ideal for corporate travelers, families, tourists, students, and individual passengers."
  },
  {
    question: "How can I book a Pune to Borivali cab with Trustline Travels?",
    answer: "Simply provide your pickup address, Borivali destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Kulkarni",
    feedback: "The journey to Borivali was managed with excellent professionalism. The driver maintained perfect timing, the vehicle was exceptionally clean, and the overall travel experience was smooth from beginning to end.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Shah",
    feedback: "Trustline Travels delivered exactly what was promised. Comfortable seating, courteous service, and efficient route planning made the Pune to Borivali trip relaxing and enjoyable throughout the journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Borivali Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-borivali-cab.webp",
  "description": "Book Pune to Borivali cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6358"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-borivali-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Borivali Cab | One Way & Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Borivali cab service with Trustline Travels for reliable intercity travel. Get affordable one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="borivali to pune cab, borivali to pune cab service, borivali to pune car, borivali to pune taxi fare, borivali to pune taxi, borivali to pune taxi service, Pune to Borivali Cab, Pune to Borivali Cab Service, Pune to Borivali Taxi, Pune to Borivali Taxi Service, Pune to Borivali Cab Booking, Pune to Borivali One Way Cab, Pune to Borivali Round Trip Cab, Pune to Borivali Outstation Cab, Pune Borivali car rental, Pune Borivali private taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoborivalicab;